import { all, call, put, takeEvery } from 'redux-saga/effects'
import { actions as liveFeedActions } from './LiveFeedSlice'

function* handleLiveFeedRequest(services, { payload }) {
  const LiveFeedRepository = services('LiveFeedRepository')

  const tags = payload

  try {
    const { data } = yield call([LiveFeedRepository, 'getLiveFeed'], tags)

    if (data?.articles) {
      yield put(liveFeedActions.requestLiveFeedSuccess(data.articles))
    } else {
      yield put(liveFeedActions.requestLiveFeedFailed())
    }
  } catch (error) {
    console.error('[LiveFeedSaga] Request failed:', error)
    yield put(liveFeedActions.requestLiveFeedFailed())
  }
}

export default function* watchLiveFeedRequest(services) {
  yield all([
    takeEvery(liveFeedActions.requestLiveFeed, handleLiveFeedRequest, services)
  ])
}
